import { useState } from 'react'
import { Create, SimpleForm, TopToolbar } from 'react-admin'
import { ToggleI18nButton, UpsertCategory } from '~/components'

const CategoryCreateActions = ({ data, showI18n, setShowI18n }) => (
  <TopToolbar>
    <ToggleI18nButton showI18n={showI18n} setShowI18n={setShowI18n} />
  </TopToolbar>
)

const CategoryCreate = (props) => {
  const [showI18n, setShowI18n] = useState(false)

  return (
    <Create
      title='resources.categories.create'
      actions={<CategoryCreateActions showI18n={showI18n} setShowI18n={setShowI18n} />}
      {...props}
      redirect='list'
    >
      <SimpleForm warnWhenUnsavedChanges>
        <UpsertCategory {...props} showI18n={showI18n} />
      </SimpleForm>
    </Create>
  )
}

export default CategoryCreate
